'use client';

import Fallback from './Fallback';
import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {}

  componentDidUpdate(prevProps) {
    if (prevProps.children !== this.props.children) {
      this.setState({ hasError: false });
    }
  }

  reload() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ? (
        this.props.fallback
      ) : (
        <Fallback
          layout={this.props.layout ? this.props.layout : 'lg'}
          reset={this.props.reset ? this.props.reset : this.reload}
        />
      );
    }

    return this.props.children;
  }
}
